import { create } from 'zustand';

export interface GenerationConfig {
  enabled: boolean;
  provider: 'meshy' | 'local' | null;
  capabilities: { text: boolean; image: boolean };
}

interface ConfigState {
  generation: GenerationConfig;
  dev: boolean;
  loaded: boolean;
  fetchConfig: () => Promise<void>;
}

const DEFAULT_GENERATION: GenerationConfig = {
  enabled: false,
  provider: null,
  capabilities: { text: false, image: false },
};

export const useConfigStore = create<ConfigState>((set) => ({
  generation: DEFAULT_GENERATION,
  dev: false,
  loaded: false,
  fetchConfig: async () => {
    try {
      const res = await import('../lib/api').then((m) => m.apiFetch('/api/config'));
      if (res.ok) {
        const data = (await res.json()) as { generation?: GenerationConfig; dev?: boolean };
        set({
          generation: data.generation ?? DEFAULT_GENERATION,
          dev: data.dev ?? false,
          loaded: true,
        });
      } else {
        set({ generation: DEFAULT_GENERATION, dev: false, loaded: true });
      }
    } catch {
      set({ generation: DEFAULT_GENERATION, dev: false, loaded: true });
    }
  },
}));
